import styled from "@emotion/styled";
import { Box } from "@mui/material";
import { HEADER_AND_TAB_HEIGHT } from "../../../ChatInfo.style";

export const PatientGroupInfoWrapper = styled(Box)`
  max-height: calc(100dvh - ${HEADER_AND_TAB_HEIGHT}px);
  overflow: auto;
`;
